import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-gray-100 py-12"
}
const _hoisted_2 = { class: "container mx-auto px-4 lg:px-40 max-w-5xl" }
const _hoisted_3 = { class: "flex flex-wrap space-y-4 md:space-y-0 mt-6 py-4 border border-gray-500 rounded-md shadow-lg" }
const _hoisted_4 = { class: "w-full text-center font-semibold" }
const _hoisted_5 = { class: "font-bold text-gray-800 mb-0 text-3xl text-center pt-3 font-antonio-bold" }
const _hoisted_6 = { class: "font-bold text-gray-800 mb-0 text-3xl text-center pt-3 font-antonio-bold" }
const _hoisted_7 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, { class: "space-y-4 text-gray-700 pb-96" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.formData.nombre) + " " + _toDisplayString(_ctx.formData.apellido), 1),
                _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.formData.mail), 1),
                _cache[0] || (_cache[0] = _createElementVNode("h1", {
                  class: "font-bold text-gray-800 mb-0 text-3xl text-center py-14 font-antonio-bold",
                  style: {"color":"#418ea7"}
                }, " Tu correo fue verificado con éxito ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", {
                href: "https://cordobatechweek.com",
                target: "web",
                class: "text-center mt-4 px-4 w-full py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_9, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _cache[1] || (_cache[1] = _createTextVNode("IR A LA WEB DEL EVENTO "))
              ], 8, _hoisted_8)
            ])
          ]),
          _createVNode(_component_BlockUI, {
            blocked: _ctx.isSubmitting,
            fullScreen: ""
          }, null, 8, ["blocked"])
        ]),
        _: 1
      })
    ])
  ], 64))
}